<template>
    <div id="partitions_layout">
        <div v-if="customer_partitions.length == 0">
            <div class="ui center aligned red segment">
                <h5>
                    您尚未被受理任何 號碼區間
                </h5>
            </div>
        </div>
        <div v-else>
            <div class="ui segment blue">
                <h5>可用的號碼區間</h5>

                <div class="ui doubling two column grid">
                    <div class="column" v-for="partition in customer_partitions">
                        <div class="ui center aligned segment">
                            <div class="ui mini statistic">
                                <div class="value">
                                    <span :data-tooltip="'字軌'" :data-position="'bottom left'">
                                        {{ partition.prefix }}
                                    </span>
                                    <span style="text-decoration: underline;">
                                        <span :data-tooltip="'起始號碼'" :data-position="'bottom center'">
                                            {{ integer_rjust(partition.from_number, partition.digit, "0") }}
                                        </span>
                                        <span> ~ </span>
                                        <span :data-tooltip="'結束號碼'" :data-position="'bottom center'">
                                            {{ integer_rjust(partition.to_number, partition.digit, "0") }}
                                        </span>
                                    </span>
                                </div>
                                <div class="label">
                                    共{{ partition.to_number - partition.from_number +1 }}筆
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ui center aligned segment"
                v-bind:class="search_result_color"
            >
                <h5 class="left floated">搜尋號碼是否已使用</h5>
                <div class="clear"></div>

                <div v-dropdown class="ui selection dropdown" v-if="customer_partitions">
                    <div class="text">
                        {{ search_prefix }}
                    </div>
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div
                            v-for="partition in customer_partitions"
                            @click="search_prefix = partition.prefix"
                            class="item"
                            :class="{
                                'selected active': search_prefix == partition.prefix
                            }">
                            {{ partition.prefix }}
                        </div>
                    </div>
                </div>

                <div class="ui action input" @keypress.enter="searching()">
                    <input type="text" placeholder="流水號" v-model="search_number">
                    <button class="ui icon button" @click="searching">
                        <i class="search icon"></i>
                    </button>
                </div>
                <p>
                    {{ search_result }}
                </p>
                <div class="ui two column grid" v-if="not_useds.length + useds.length">
                    <div class="column">
                        <p>未使用號碼</p>
                        <div class="ui blue segment">
                            <p v-for="not_used in not_useds">
                                {{ not_used }}
                            </p>
                            <div class="ui basic vertical animated button" tabindex="0"
                                v-if="not_useds.length > 2"
                                @click="sort_not_useds()"
                            >
                                <div class="hidden content">排序</div>
                                <div class="visible content">
                                    <i class="sort numeric ascending icon"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="column">
                        <p>已使用號碼</p>
                        <div class="ui green segment">
                            <p v-for="used in useds">
                                {{ used }}
                            </p>
                            <div class="ui basic vertical animated button" tabindex="0"
                                v-if="useds.length > 2"
                                @click="sort_useds()"
                            >
                                <div class="hidden content">排序</div>
                                    <div class="visible content">
                                    <i class="sort numeric ascending icon"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="ui active centered inline large loader"></div> -->
    </div>
</template>

<script>

export default {
    data() {
        return {
            is_initialized: false,
            search_result_color: "olive",
            search_result: "",
            search_prefix: "",
            search_number: "",
        }
    },
    computed: {
        customer_partitions() {
            return this.$store.state.customer.customer_partitions;
        },
        not_useds() {
            return this.$store.state.customer.partitions_module.not_useds;
        },
        useds() {
            return this.$store.state.customer.partitions_module.useds;
        },
    },
    watch: {
    },
    created() {
        var that = this;


        that.init();
        that.set_breadcrumbs();
    },
    mounted: function() {
        var that = this;



        that.search_prefix = (that.customer_partitions.length > 0)
            ? that.customer_partitions[0].prefix
            : "" ;
    },
    methods: {
        integer_rjust(integer, width, padding) {
            return integer.toString().rjust(width, padding);
        },
        init() {
            var that = this;

            const promise = new Promise(function(resolve, reject) {
                resolve();
            })

            promise.then(function() {
                that.is_initialized = false;
            }).then(function() {
                that.$noty.information(
                    that.$t("ui.page_titles.customer_partitions") + ' ' +
                    that.$t('ui.general.initialize_complete')
                , 300);
                that.is_initialized = true;
            }).catch(function (error) {
                switch (error) {
                    default:
                }
            });
        },
        searching() {
            var that = this;

            if (that.validate_number()) {
                that.search_result = "";
                that.search_result_color = "green";

                var focus_partition = _.find(that.customer_partitions, function(partition) {
                    return partition.prefix == that.search_prefix
                });
                var search_number = that.integer_rjust(that.search_number, focus_partition.digit, "0");
                var url = that.$store.state.customer.routes.api_v1_provider_core_waybill_search;

                axios.post(
                    url,
                    {
                        "number": that.search_prefix + search_number
                    },
                    {
                        headers: { Authorization: localStorage.getItem("authentication_token") }
                    }
                ).then(function (response) {
                        if (response.data.status == "success") {
                            var number = that.search_prefix +" "+ search_number
                            if (response.data.core_waybill.is_used) {
                                that.search_result = "已使用";
                                that.useds.push(number);
                            } else {
                                that.not_useds.push(number);
                                that.search_result = "未使用";
                            }
                        } else {
                            that.search_result = "查詢運單失敗";
                        }
                    })
                    .catch(function (error) {
                        // that.$noty.error('取得運單失敗');
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.core_waybills'),
                                reason: ': ' + error
                            })
                        );
                    });

            } else {
                that.search_result = (!that.search_number) ? "請輸入流水號號" : "非合法號碼";
                that.search_result_color = "red";
            }
        },
        validate_number() {
            var that = this;

            var partition = _.find(that.customer_partitions, function(partition) {
                return partition.prefix == that.search_prefix;
            });

            if (! partition) return false;

            if (
                (that.search_number >= partition.from_number) &&
                (partition.to_number >= that.search_number)
            ) {
                return true;
            }

            return false;
        },
        sort_not_useds() {
            var that = this;
            that.$store.state.customer.partitions_module.not_useds = _(that.not_useds).sortBy().sortedUniq().value();
        },
        sort_useds() {
            var that = this;
            that.$store.state.customer.partitions_module.useds = _(that.useds).sortBy().sortedUniq().value();
        },
        set_breadcrumbs() {
            var that = this;
            var index = {
                route_name: 'partitions',
                name: '號碼區間'
            };

            switch (that.$route.name) {
                case 'partitions':
                    that.$store.state.breadcrumbs = [index];
                    break;
                default:
            }
        },
    },
    components: {
    }
}

</script>
<style scoped lang="scss">
    .doubling.two.grid .column {
        padding: 8px;
    }
    .ui.selection.dropdown {
        text-align: center;
    }
    .segment .ui.basic.animated.button {
        position: absolute;
        right: 3px;
        top: 9px;
    }
</style>
